<template>
  <table id="cart" class="table table-hover table-condensed">
    <thead>
      <tr>
        <th style="width:50%"></th>
        <th style="width:10%"></th>
        <th style="width:8%" ></th>
        <th style="width:22%"></th>
        <th style="width:10%"></th>
      </tr>
    </thead>
    <tbody v-for="product in products" track-by="$index">
      <tr>
        <td data-th="">
          <div class="row">
            <!-- <a v-link="{ name: 'Product', params: { id: product.ProductId, pname: $options.filters.slugurl(product.Name) }}"> -->
            <div class="col-sm-4"><img v-lazy="product.Photos[0].URL" class="img-responsive"/></div>
            <div class="col-sm-8">
              <h4 class="nomargin">{{product.Name}}</h4>
            </div>
            <!-- </a> -->
<!--             <div class="col-sm-6 visible-xs">
              {{product.Price | currencyDisplay}}
            </div> -->
          </div>
        </td>
        <td class="text-right">
          <h4 style="padding-top:0px;"><strong>{{product.Quantity}}x</strong></h4>
        </td>
        <td colspan="3" class="text-right">
          <h4 style="padding-top:0px;"><strong>{{product.Price | currencyDisplay}}</strong></h4>
        </td>
      </tr>
    </tbody>
    <tfoot>
<!--       <tr class="visible-xs">
        <td class="text-center">
          <p><strong>subtotaal {{subtotal | currencyDisplay}}</strong></p>
          <p>
            <strong>Verzendkosten {{shippingcost | currencyDisplay}}</strong>
          </p>
          <h3><strong>Totaal {{totalprice | currencyDisplay}}</strong></h3>
        </td>
      </tr> -->
      <tr>
        <td colspan="3" class=""></td>
        <td colspan="2" class=" text-right">
        <p><strong>subtotaal {{subtotal | currencyDisplay}}</strong></p>
        <p>
          <strong>Verzendkosten {{shippingcost | currencyDisplay}}</strong>
        </p>
        <h3><strong>Totaal {{totalprice | currencyDisplay}}</strong></h3>
        </td>
      </tr>
    </tfoot>
  </table>
</template>
<script>
export default {
  props: {
    products: {
      type: Array,
      required: true
    },
    subtotal: {
      type: Number,
      required: true,
      twoWay: true
    },
    shippingcost: {
      type: Number,
      required: true,
      twoWay: true
    },
    totalprice: {
      type: Number,
      required: true,
      twoWay: true
    }
  },
  created () {
  },
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>


// WEBPACK FOOTER //
// betalen-cart.vue?ca8ee10a